import React from "react";
import "./HerbsSection.css";
import condStress from "../assets/icons/cond_stress.svg";
import condImmune from "../assets/icons/cond_immune.svg";
import condSleep from "../assets/icons/cond_sleep.svg";
import condEnergy from "../assets/icons/cond_energy.svg";
import condWomens from "../assets/icons/cond_womens.svg";
import condMens from "../assets/icons/cond_mens.svg";
import condHormonal from "../assets/icons/cond_hormonal.svg";
// import condInflammation from "../assets/icons/cond_inflammation.svg";
import condDigestive from "../assets/icons/cond_digestive.svg";
import condHair from "../assets/icons/cond_hair.svg";
import condMore from "../assets/icons/cond_more.svg";
import sectionLabel from "../assets/icons/section_label.svg";

const conditions = [
  { icon: condStress, label: "Stress, mood & nervous system support" },
  { icon: condImmune, label: "Immune support and allergies" },
  { icon: condSleep, label: "Sleep and nervous system regulation" },
  { icon: condEnergy, label: "Energy and chronic fatigue" },
  {
    icon: condWomens,
    label: "Cycle, fertility & menopause support",
  },
  { icon: condMens, label: "Men\u2019s health and vitality" },
  { icon: condHormonal, label: "Hormonal balance and endocrine health" },
  // { icon: condInflammation, label: "Chronic inflammation and pain" },
  { icon: condDigestive, label: "Digestive issues and bloating" },
  {
    icon: condHair,
    label: "Hair, skin & beauty Inflammation & recovery support",
  },
  {
    icon: condMore,
    label:
      "And more \u2014 because every formula is built around your unique presentation.",
    wide: true,
  },
];

function HerbsSection() {
  return (
    <section className="herbs-section">
      <div className="herbs-container">
        <div className="herbs-header">
          <div className="herbs-section-label">
            <img src={sectionLabel} alt="" width="192" height="32" />
          </div>
          <h2 className="herbs-title">
            Personalized support for the conditions that matter most
          </h2>
        </div>

        <div className="herbs-grid">
          {conditions.map((item, i) => (
            <div
              className={`herbs-condition-card${item.wide ? " herbs-condition-card--wide" : ""}`}
              key={i}
            >
              <div className="herbs-condition-icon">
                <img src={item.icon} alt="" width="64" height="64" />
              </div>
              <p className="herbs-condition-label">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HerbsSection;
